import interceptor from '@/plugins/interceptor';
const linksPath = '/Links';
const courseInstancesPath = '/CoursesInstances';

export default {
    actions: {
        async links_getCreationOptions() {
            return await interceptor.authenticate.get(`${process.env.VUE_APP_API_LMS_ADMIN_URL}${linksPath}/creationOptions`);
        },
        async links_getLinks(_, params) {
            return await interceptor.authenticate.get(`${process.env.VUE_APP_API_LMS_ADMIN_URL}${linksPath}?pageNumber=${params.page}&rowsPerPage=${params.rows}&status=${params.status}&forgeUserId=${params.forgeUserId}&country=${params.country}`);
        },
        async links_getCoursesOnDemand() {
        return await interceptor.authenticate.get(
            `${process.env.VUE_APP_API_LMS_ADMIN_URL}${courseInstancesPath}/onDemand`
        );
        },
        async links_postLink(_, params) {
            return await interceptor.authenticate.post(`${process.env.VUE_APP_API_LMS_ADMIN_URL}${linksPath}`, params);
        },
        async links_editLink(_, params) {
            return await interceptor.authenticate.put(`${process.env.VUE_APP_API_LMS_ADMIN_URL}${linksPath}/${params.id}`, params);
        },
        async links_deactivateLink(_, params) {
            return await interceptor.authenticate.put(`${process.env.VUE_APP_API_LMS_ADMIN_URL}${linksPath}/${params}/inactive`);
        },
        async links_getShortUrl(_, linkId) {
            return await interceptor.authenticate.put(`${process.env.VUE_APP_API_LMS_ADMIN_URL}${linksPath}/${linkId}/shortUrl`);
        },
        async customLink_getCourseId(_,name) {
            return await interceptor.anonymous.get(`${process.env.VUE_APP_API_LMS_URL}${linksPath}/${name}/info`);
        }
    }
}
